import {createRouter, createWebHashHistory} from 'vue-router';

const routes = [{
    path: '/', name: 'index', component: () => import('../views/Index.vue'), meta: {keepAlive: true}
}, {
    path: '/indexApp', name: 'indexApp', component: () => import('../views/IndexApp.vue'), meta: {keepAlive: true}
}, {
    path: '/loginApp', name: 'loginApp', component: () => import('../views/LoginApp.vue'), meta: {keepAlive: false}
}, {
    path: '/login', name: 'login', component: () => import('../views/Login.vue'), meta: {keepAlive: true}
}, {
    path: '/choose', name: 'choose', component: () => import('../views/Choose.vue'), meta: {keepAlive: true}
}, {
    path: '/chooseApp', name: 'chooseApp', component: () => import('../views/ChooseApp.vue'), meta: {keepAlive: true}
}, {
    path: '/aboutApp', name: 'aboutApp', component: () => import('../views/AboutApp.vue'), meta: {keepAlive: false}
}, {
    path: '/topMenu',
    name: 'topMenu',
    component: () => import('../components/TopMenu.vue'),
    meta: {keepAlive: true},
    children: [{
        path: 'asked', name: 'asked', component: () => import('../views/Asked2.vue'), meta: {keepAlive: true}
    }, {
        path: 'said', name: 'said', component: () => import('../views/Said2.vue'), meta: {keepAlive: true}
    }, {
        path: 'historical',
        name: 'historical',
        component: () => import('../views/Historical.vue'),
        meta: {keepAlive: false}
    }, {
        path: 'about', name: 'about', component: () => import('../views/About.vue'), meta: {keepAlive: false}
    }],
    redirect: '/topMenu/asked'
}, {
    path: '/topMenuApp',
    name: 'topMenuApp',
    component: () => import('../components/TopMenuApp.vue'),
    meta: {keepAlive: true},
    children: [{
        path: 'asked', name: 'askedApp', component: () => import('../views/AskedApp2.vue'), meta: {keepAlive: true}
    }, {
        path: 'said', name: 'saidApp', component: () => import('../views/SaidApp2.vue'), meta: {keepAlive: true}
    },{
        path: 'historical',
        name: 'historicalApp',
        component: () => import('../views/HistoricalApp.vue'),
        meta: {keepAlive: false}
    }],
    redirect: '/topMenuApp/asked'
}];

const router = createRouter({
    history: createWebHashHistory(), routes
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');

    // 屏幕宽高比判断
    const isPortrait = window.innerHeight > window.innerWidth; // 竖屏
    const isLandscape = !isPortrait; // 横屏或宽屏

    // 如果是根访问时，根据屏幕方向重定向
    if (to.path === '/') {
        if (isPortrait) {
            next('/indexApp');
            return;
        } else {
            next();
            return;
        }
    }

    if (to.path === '/indexApp') {
        if (isLandscape) {
            next('/');
            return;
        }
    }
    // 登录路由允许访问
    if (to.path === '/login' || to.path === '/loginApp') {
        next();
        return;
    }
    // token 校验
    if (token) {
        next();
    } else {
        if (isLandscape) {
            next('/login');
        } else {
            next('/loginApp');
        }
    }
});

export default router;
